/**
 * GoalSection — ein Abschnitt für Ziele, die an KEINER Komponente hängen.
 *
 * Warum es ihn gibt: 15 der 31 Ziele zeigen nicht auf eine Komponente
 * (8 Artefakt-Typen, 3 Mechanismen, 3 Workstreams, 1 Repo ohne Kataster-
 * Eintrag). Eine reine Kopie der Architekturübersicht hätte für sie keinen
 * Platz — und da alle anderen Seiten die Ziele verlieren, wären sie damit aus
 * dem Produkt verschwunden. Diese Abschnitte sind der Ort, an dem sie bleiben.
 *
 * Dieselbe Zeilenform wie am Knoten: links die Einheit, in der Mitte das Ziel
 * aus Atlassian, rechts — getrennt und beschriftet — der abgeleitete Grad.
 */
import { Card } from "@conuti-das/prince-ui";
import { GoalFacts, GradeCell } from "./GoalLine";
import { gradeForRef, type GoalSectionData } from "./grade";
import "./goals.css";

export function GoalSection({ section }: { section: GoalSectionData }) {
  const headId = `ug-sec-${section.id}`;
  return (
    <section className="ug-section" aria-labelledby={headId}>
      <h3 className="ug-section-title" id={headId}>
        {section.title}
        <span className="ug-section-count">{section.goals.length}</span>
      </h3>
      <p className="ug-section-hint">{section.hint}</p>
      <Card padding="none" className="ug-table">
        <div className="ug-row ug-row--head" aria-hidden="true">
          <span className="ug-cell-unit">Einheit</span>
          <span className="ug-cell-goal">Ziel · Zieldatum · Status (Atlassian)</span>
          <span className="ug-cell-grade">Umsetzungsgrad (abgeleitet)</span>
        </div>
        {section.goals.map((g) => (
          <div className="ug-row" key={g.ref} data-goal-ref={g.ref}>
            <span className="ug-cell-unit">
              <code className="ug-ref">{g.ref}</code>
              <span className="ug-goalname">{g.name ?? "ohne Namen im Snapshot"}</span>
            </span>
            <span className="ug-cell-goal goalline-goal">
              <GoalFacts refId={g.ref} />
            </span>
            <span className="ug-cell-grade">
              <GradeCell grade={gradeForRef(g.ref)} />
            </span>
          </div>
        ))}
      </Card>
    </section>
  );
}
